import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import PostsList from './PostsList';
import GridCell from './GridCell';
import FourZeroFour from './FourZeroFour';
import Loading from './Loading';

import slugify from '../slugify';


// The Post looks up the project using the slug parsed from
// the URL's pathname. If no project is found with the given
// slug, then a "project not found" message is displayed.
class Post extends Component {
  state = {
    post: {},
    postTitleHideShow: '',
    postTitleNumberHideShow: '',
    postStatsNumberHideShow: '',
  }

  async componentWillMount() {
    if (this.props.postType === 'Project') {
      await this.props.loadData('/data/project_data.json', 'projects'); // put project data in state on App
      //const isDataLoaded = await this.props.loadData('/data/project_data.json', 'projects'); // put project data in state on App
    }
    if (this.props.postType === 'BlogPost') {
      await this.props.loadData('/data/blog_data.json', 'blogPosts'); // put blog data in state on App
      //const isDataLoaded = await this.props.loadData('/data/blog_data.json', 'blogPosts'); // put blog data in state on App
    }

    // loadData function returns a promise so can use await it

    // console.log(isDataLoaded);
    // console.log('componentWillMount');

    // get project that matches the URL
    const isPost = (item, index) => {
      if (item.slug === this.props.match.params.slug) {
        this.postIndex = index;
      }
      return item.slug === this.props.match.params.slug; // returns the array item if that item's slug matches the requested project's slug
    };
    const post = this.props.posts.find(isPost); // The find() method returns the value of the first element in the array that satisfies the provided testing function
    this.gotPosts = true;
    this.setState({
      post,
    });
    // console.log('this.post = ', this.post);
    // console.log('this.props.posts = ', this.props.posts);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ postTitleHideShow: 'show' });
    }, 250);
    setTimeout(() => {
      this.setState({ postTitleNumberHideShow: 'show' });
    }, 500);
    setTimeout(() => {
      this.setState({ postStatsNumberHideShow: 'show' });
    }, 750);
  }

  gotPosts = false;

  // check if object is empty
  // https://coderwall.com/p/_g3x9q/how-to-check-if-javascript-object-is-empty
  /* eslint-disable */
  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) { return false; }
    }
    return true;
  }

  twoDigitNumber(n) { // https://stackoverflow.com/questions/8043026/javascript-format-number-to-have-2-digit
    return n > 9 ? `${n}` : `0${n}`;
  }
  /* eslint-enable */

  render() {
    const { post } = this.state;

    if (!this.gotPosts) { // if haven't loaded up the post data yet
      return (
        <div className="loading"><Loading /></div>
      );
    }

    if (this.isEmpty(post)) { // if state.post is empty, then the post was not found and return a 404
      // return <div className="loading"><Signature /></div>;
      return (
        <FourZeroFour />
      );
    }


    return (
      <div className={`${post.slug} main-${this.props.postType.toLowerCase()}`}>

        <Helmet>
          <title>{`${post.title.map(palabra => palabra.word).join(' ')} - Dan Ohlsen`}</title>
        </Helmet>

        {/* HEADER */}
        <header className="band post-header" style={this.props.postType === 'Project' ? { backgroundColor: `#${post.bgcolor}` } : null}>
          <div className={`grid-row ${this.props.postType === 'Project' ? 'grid-1-7-4' : 'grid-10'} post-header__grid-row`}>

            <div className={`grid-cell post-title__grid-cell ${this.props.postType === 'Project' ? 'grid-cell--left-align' : null}`}>
              <div className="post-title-lockup">
                { /* If-Else in JSX https://react-cn.github.io/react/tips/if-else-in-JSX.html */
                  (() => {
                    if (this.props.postType === 'Project') {
                      return (
                        <span className={`post-title__number ${this.state.postTitleNumberHideShow}`}>{this.twoDigitNumber(this.postIndex + 1)}</span>
                      );
                    }
                  })()
                }

                <h1 className={`post-title ${post.svg_title === 'false' ? 'no-svg' : ''} ${this.state.postTitleHideShow}`} style={{ fontSize: post.font_size ? post.font_size : null }}>
                  {
                    post.title.map((palabra) => {
                      if (post.svg_title === 'true') {
                        return (
                          <span key={palabra.id}>
                            <span className={`post-title__word post-title__${palabra.id}`}>
                              <svg role="img" aria-hidden="true" className="post-title__svg" style={palabra.width ? { width: `${palabra.width}em` } : null}>
                                <use xlinkHref={`/img/${this.props.postType === 'BlogPost' ? post.slug : 'project-titles'}.svg#${palabra.id}`} />
                              </svg>
                              <span className="visuallyhidden">{palabra.word}</span>
                            </span>{' '}
                          </span>
                        );
                      }
                        return (
                          <span key={palabra.id} className="post-title__word-nosvg" style={{ fontFamily: post.font_family, fontWeight: post.font_weight }}>
                            {`${palabra.word} `}
                          </span>
                        );
                    })
                  }
                </h1>

              </div>
            </div>

            { /* STATS  */
              /* If-Else in JSX https://react-cn.github.io/react/tips/if-else-in-JSX.html */
                (() => {
                  if (this.props.postType === 'Project') {
                    return (
                      <div className="grid-cell grid-cell--left-align post-stats__grid-cell">
                        <section className={`post-stats ${this.state.postStatsNumberHideShow}`}>
                          {
                            post.stats.map(stat => (
                              <dl key={slugify(stat.hed, { lower: true })} className="post-stats__list">
                                <dt className="post-stats__hed">{stat.hed}</dt>
                                {
                                  stat.items.map(item => (
                                    <dd key={slugify(item.text, { lower: true })} className="post-stats__item">
                                      { /* If-Else in JSX https://react-cn.github.io/react/tips/if-else-in-JSX.html */
                                        item.url ?
                                          <Link to={item.url}>{item.text}</Link> :
                                          <span>{item.text}</span>
                                      }
                                    </dd>),
                                )}
                              </dl>),
                          )}
                        </section>
                      </div>
                    );
                  }
                })()
              }


          </div>
        </header>


        {/* POST BODY */}
        <section className="post-body">
          {
            post.rows.map(row => (
              <div key={row.id} className="band" id={row.id ? row.id : null} style={row.bgcolor ? { backgroundColor: `#${row.bgcolor}` } : null}>
                <div className={`grid-row ${row.classes ? row.classes.join(' ') : ''}`}>
                  {
                    row.grid_cells.map(gridCell => (
                      <GridCell key={gridCell.id} gridCell={gridCell} />
                    )) // end map
                  }
                </div>
              </div>
            ))
          }
        </section>

        {/* POST FOOT */}
        <aside className="post-foot">
          <PostsList posts={this.props.posts} postType={`${this.props.postType}s`} loadData={this.props.loadData} />
        </aside>

      </div>
    );
  }
}

Post.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object).isRequired,
  loadData: PropTypes.func.isRequired,
  postType: PropTypes.string.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Post;



// WEBPACK FOOTER //
// ./src/components/Post.js